import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertTriangle } from 'lucide-react';
import { API } from '@/App';
import { Button } from '@/components/ui/button';

export const DunningBanner = ({ dunning }) => {
  const [busy, setBusy] = useState(false);
  if (!dunning) return null;
  const retry = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/billing/dunning/retry`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      if (r.data.url) window.open(r.data.url, '_blank', 'noopener');
      else if (r.data.resubscribe) { toast.info('This subscription has ended — pick a plan below to resubscribe.'); document.querySelector('[data-testid="pricing-testimonial-strip"]')?.scrollIntoView({ behavior: 'smooth' }); }
      else toast.info('Razorpay will retry the charge automatically. Please make sure your card has funds.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not open the payment page');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="rounded-2xl border-2 border-red-200 bg-red-50/80 p-4 flex flex-wrap items-center gap-3" data-testid="dunning-banner">
      <AlertTriangle className="text-red-600" size={20} />
      <div className="flex-1 min-w-[220px] text-sm text-red-900">
        <b>Your last payment failed.</b> Retry or update your card before {new Date(dunning.grace_until).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })} to keep access.
      </div>
      <Button onClick={retry} disabled={busy} className="bg-red-600 hover:bg-red-700 text-white" data-testid="dunning-retry-btn">{busy ? 'Opening…' : 'Retry payment'}</Button>
    </div>
  );
};
